import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
@Component({
  selector: 'nx-ng-textfield',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TextFieldComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextFieldComponent implements ControlValueAccessor {
  @Input()
  id = '';
  @Input()
  label = '';
  @Input()
  placeholder = '';
  @Input()
  errorText = '';
  @Input()
  isRequired = false;
  @Input()
  type: 'text' | 'number' = 'text';
  @Input()
  max: number | undefined = undefined;
  @Input()
  isLoading: boolean | undefined = false;
  @Input()
  successIcon = false;
  @Input()
  readonly = false;
  @Output()
  change: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  enter: EventEmitter<void> = new EventEmitter<void>();


  private localValue = '';
  private touched = false;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  set value(value: any) {
    this.localValue = value;
    this.onChange(value);
    this.change.emit(value);
  }

  get value(): any {
    return this.localValue;
  }

  onChange = (event: any) => {};
  onTouch = () => {};

  writeValue(value: any) {
    this.localValue = value;
    if (this.changeDetectorRef) {
      this.changeDetectorRef.markForCheck();
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  get errorId() {
    return `${this.id}-error`;
  }

  get hasError() {
    return this.errorText?.length > 0;
  }

  markAsTouched() {
    if (!this.touched) {
      this.touched = true;
      this.onTouch();
    }
  }

  handleKeydown(event: KeyboardEvent) {
    const isDigit = event.key >= '0' && event.key <= '9';
    const isEnter = event.key === 'Enter';

    if (isEnter) {
      this.enter.emit();
      event.preventDefault();
    }

    const target = event.target as HTMLInputElement;
    const value = target?.value;

    if (!value) {
      return;
    }

    if (isDigit && this.max && Number(value) > this.max) {
      event.preventDefault();
    }
  }
}
